import getOr from 'lodash/fp/getOr'

const getConfig = (path?: string, defaultValue = ''): any => {
  const winEnv =
    typeof window !== 'undefined' && (window as any).env && Object.keys((window as any).env).length > 0
      ? (window as any).env
      : null

  // Only use process.env when it's not an empty object and not containing only NODE_ENV
  const isNonTrivialProcessEnv = (env?: Record<string, any> | null): boolean =>
    !!env &&
    Object.keys(env).length > 0 &&
    !(Object.keys(env).length === 1 && Object.prototype.hasOwnProperty.call(env, 'NODE_ENV'))

  const procEnv = typeof process !== 'undefined' && isNonTrivialProcessEnv(process.env) ? process.env : null

  const configs = procEnv || winEnv || {}

  if (typeof path === 'undefined' || path === null) return configs
  return getOr(defaultValue, path, configs)
}

export default getConfig
